import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "2 2 20 20",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M4.75 14.75V16.25C4.75 17.9069 6.09315 19.25 7.75 19.25H16.25C17.9069 19.25 19.25 17.9069 19.25 16.25V14.75"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M12 14.25L12 4.75"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M8.75 10.75L12 14.25L15.25 10.75"
		})
	]
});
export default SvgDownload;
